import React from 'react';
import * as fonts from '../../../../../util/fonts';
import {getColor} from '../../../../../util/utility';

interface CheckboxTextProps extends React.HTMLProps<HTMLDivElement> {
  text: any;
  textLink: any;
  textUrl: any;
}

function CheckboxText({text, textLink, textUrl}: CheckboxTextProps) {
  return (
    <span style={{...fonts.MM}}>
      {text}{' '}
      {
        <a style={getColor('color')} href={textUrl} target="_blank">
          {textLink}
        </a>
      }
      {'.'}
    </span>
  );
}

export default CheckboxText;
